import { Button, Image, Divider } from "antd";
import { useState } from "react";
import { ShoppingCartOutlined } from "@ant-design/icons";

import Text from "components/Text";

import * as Styled from '../../../../styled';

/**
 * SupportParentCategoryPanel
 * @param {*} props 
 * @returns 
 */
const SupportParentCategoryPanel = ({ supportParentCategory, getAllVariantsFromSupportParentCategory, handleOnSelectVariant }) => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      {
        supportParentCategory.pictures && supportParentCategory.pictures.length > 0 && (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Image
              preview={{
                visible: false,
              }}
              width={300}
              src={`${process.env.REACT_APP_S3_FILES_URL}${supportParentCategory.pictures[0]}`} 
              onClick={() => setVisible(true)}
            />
            
            <div style={{ display: 'none '}}>
              <Image.PreviewGroup
                preview={{
                  visible,
                  onVisibleChange: (vis) => setVisible(vis),
                }}
              >
                {
                  supportParentCategory.pictures.map((picture, index) => (
                    <Image 
                      key={`picture-${index}`}
                      src={`${process.env.REACT_APP_S3_FILES_URL}${picture}`} 
                    />
                  ))
                }
              </Image.PreviewGroup>
            </div>
          </div>
        )
      }
      
      <Text style={{ marginTop: 10 }}>{supportParentCategory.description_i18n['fr']}</Text>
      
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
        {
          supportParentCategory.video && (
            <a href={supportParentCategory.video.url} target="_blank" rel="noreferrer">{supportParentCategory.video.label}</a>
          )
        }
      </div>

      <Divider />

      {
        getAllVariantsFromSupportParentCategory(supportParentCategory).map((variant) => (
          <Styled.EffectSelectionItem
            key={`${supportParentCategory._id}-variant-${variant.id}`}
            style={{ display: 'flex', flexDirection: 'column' }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%'  }}>
              <Text size={15} style={{ marginLeft: 10 }}>{variant.name_fr}</Text>

                <div style={{  display: 'flex', flexDirection: 'row', marginBottom: 10, marginTop: 10  }}>
                  
                  <Text size={15} style={{ marginLeft: 10, marginTop: 6 }} color="#53b6ba">{variant.public_price}€</Text>

                  <Button 
                    type="primary" 
                    style={{ marginLeft: 'auto',  width: 'fit-content' }}
                    onClick={() => handleOnSelectVariant(variant.supportCategory, variant)}
                  >
                    Ajouter au panier <ShoppingCartOutlined style={{ fontSize: 18 }} />
                  </Button>
                </div>
            </div>
          </Styled.EffectSelectionItem>    
        ))
      }
    </>
  )
}

export default SupportParentCategoryPanel;